const jobs = {
  forms: {
    information: {
      reservationDetails: {
        fields: {
          from: 'Abholort',
          to: 'Lieferort',
          seat: 'Pakete',
        },
      },
    },
  },

  table: {
    headers: {
      seats: 'Artikelmenge',
      from: 'Abholort',
      to: 'Lieferort',
      passenger: 'Name des Empfängers',
    },
    statuses: {
      picked: 'Zur Auslieferung unterwegs',
      dropped: 'Geliefert',
      noshow: 'Fehlgeschlagene Zustellung',
    },
  },
};

export default jobs;
